export default "__VITE_ASSET__D8Fkf4uk__"